import BannerImg from '../../../assets/images/hashkey-banenr.png'
import BannerImg750 from '../../../assets/images/hashkey-banenr-750.jpg'
import CloseIcon from '../../../assets/images/icons/close-icon.png'
import styled from "styled-components";
import {useState} from "react";

const BannerPlaceholder = styled.div`
  height: 60px;
  @media screen and (max-width: 1024px) {
    height: 180px;
  }
  @media screen and (max-width: 680px) {
    height: 100px;
  }
`

const BannerWrap = styled.div`
  position: absolute;
  top: -22px;
  left: 0;
  cursor: pointer;
  z-index: 1;
  @media screen and (max-width: 1024px) {
    background: url(${BannerImg750}) no-repeat center;
    height: 180px;
    background-size: cover;
  }
  @media screen and (max-width: 680px) {
    background: url(${BannerImg750}) no-repeat center;
    height: 100px;
    background-size: cover;
  }
  background: url(${BannerImg}) no-repeat center;
  background-size: cover;
  height: 60px;
  width: 100%;
  >img {
    cursor: pointer;
  }
`

const CloseBtn = styled.div`
  position: absolute;
  right: 45px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  @media screen and (max-width: 1024px) {
    top: 20px;
    right: 20px;
  }
  img {
    width: 13px;
  }
`

export const Banner = () => {
    const [state, setState] = useState(true)

    const jumpTo = (e) => {
        window.open(process.env.REACT_APP_CLAIM_DID)
    }

    if (state) return (
        <>
            <BannerWrap onClick={jumpTo}>
                {/*<img onClick={jumpTo} src={BannerImg} width='100%' alt=""/>*/}
                <CloseBtn onClick={(e) => {
                    e.stopPropagation()
                    setState(false)
                }}>
                    <img src={CloseIcon} alt=""/>
                </CloseBtn>
            </BannerWrap>
            <BannerPlaceholder />
        </>
    )
    return null
}